<template>
    <div>
        <div class='d-flex justify-content-between'>
            <h4 v-if='this.content.result == "852"'>{{ $t('components.service.modals.Repeat.1') }}</h4>
            <h4 v-else-if='this.content.result == "856"'>{{ $t('components.service.modals.Repeat.2') }}</h4>
            <h4 v-else-if='this.content.result == "858"'>{{ $t('components.service.modals.Repeat.6') }}</h4>
            <h4 v-else-if='this.content.result == "880"'>{{ $t('components.service.modals.Repeat.4') }}</h4>
            <h4 v-else-if='this.content.result == "860"'>{{ $t('components.service.modals.Repeat.9') }}</h4>
            <h4 v-else>{{this.content.result_text}}</h4>
            <i class='big item-i x_red' v-on:click='this.close'></i>
        </div>
        <div v-if='this.warn' class='row container-fluid mt-1 p-0 pb-1 g-3 neue-roman'>
            <p class='p-0 m-0 color-warning'>{{this.warn}}</p>
        </div>
        <div v-if='this.content.result == "858"' class='row container-fluid mt-1 p-0 g-3 neue-roman'>
            <p class='p-0 m-0'>{{ $t('components.service.modals.Repeat.7', { positions: this.positionsText }) }}</p>
            <InputSimple class="p-0 col-10 col-md-8 col-lg-6 col-xl-5" id='sms_confirm_value' autofocus :maxlength="this.lettersLength" @onEnter="this.submit" @updateParentState="this.updateState" hint=''/>
        </div>
        <div v-if='this.content.result == "856"' class='row container-fluid mt-1 p-0 g-3 neue-roman'>
            <p class='p-0 m-0'>{{ $t('components.service.modals.Repeat.5') }}</p>
            <InputSimple class="p-0 col-10 col-md-8 col-lg-6 col-xl-5" id='sms_confirm_value' autofocus @onEnter="this.submit" @updateParentState="this.updateState" hint=''/>
        </div>
        <div v-if='this.content.result == "880"' class='row container-fluid mt-1 p-0 g-3 neue-roman'>
            <p class='p-0 m-0' v-html="this.content.advanced.confirm_text"></p>
            <Input :label="$t('components.service.modal.Repeat.1')" id='sms_confirm_value' autofocus @onEnter="this.submit" @updateParentState="this.updateState" hint=''/>
        </div>
        <div v-if='this.content.result == "852"' class='row container-fluid mt-1 p-0 g-3 neue-roman'>
            <p class='p-0 m-0' v-html="this.content.advanced.confirm_text"></p>
            <InputSimple class="p-0 col-10 col-md-8 col-lg-6 col-xl-5" id='sms_confirm_value' autofocus @onEnter="this.submit" @updateParentState="this.updateState" hint=''/>
        </div>
        <div v-if='this.content.result == "860"' class='row container-fluid mt-1 p-0 g-3 neue-roman'>
            <p class='p-0 m-0'>{{ this.content.advanced.question }}</p>
            <InputSimple class="p-0 col-10 col-md-8 col-lg-6 col-xl-5" id='sms_confirm_value' autofocus @onEnter="this.submit" @updateParentState="this.updateState" hint=''/>
        </div>
        <div class='d-flex mx-auto justify-content-center pt-3'>
            <Button :name="$t('components.service.modal.Repeat.2')" :disabled='this.dis' :loader='this.submitLoading' type='btn-warning' v-on:click='this.submit'/>
        </div>
         
    </div>
</template>

<script>
import Button from '@/components/service/Button';
import Input from '@/components/service/Input';
import InputSimple from '@/components/service/InputSimple';

export default {
    components: {
        Button,
        Input,
        InputSimple
    },
    props: {
        close: [Function],
    },
    data () {
        return {
            content: this.$store.state.modal.content,
            sms_confirm_value: false,
            dis: true,
            warn: '',
            submitLoading: false,
            callbacks: {
                login:(res) => {
                    this.$store.commit('USER_DATA', res.data.body);
                    this.$store.commit('DARK_WRAPPER', false);
                }
            } 
        }
    },
    computed: {
        // positions для magic_word: «3-я, 7-я, 12-я» из массива [3,7,12]
        positionsText() {
            const positions = this.content.advanced && this.content.advanced.positions
                ? this.content.advanced.positions : [];
            return positions.join(', ');
        },
        // Длина ответа = число позиций. 0 = positions не пришли (race / сломанный challenge),
        // в этом случае блокируем ввод и показываем warn в шапке.
        lettersLength() {
            const positions = this.content.advanced && this.content.advanced.positions
                ? this.content.advanced.positions : [];
            return positions.length;
        },
    },
    created() {
        if (this.content.result == "858" && this.lettersLength === 0) {
            this.warn = this.content.result_text
                || this.$t('components.service.modals.Repeat.8');
        }
    },
    methods: {
        updateState(state) {
            // Обрезаем пробелы по краям: скопированный из письма/менеджера код
            // (одноразовый ключ, буквы magic-слова) часто приходит с прилипшим
            // пробелом или переносом → бэк отвечает key_wrong, хотя код верный.
            // trim, а не вырезание всех пробелов: ответ на секретный вопрос может
            // законно содержать внутренний пробел.
            this.sms_confirm_value = typeof state.value === 'string'
                ? state.value.trim() : state.value;
            // magic-challenge: кнопка активна только при вводе ровно lettersLength букв
            // (lettersLength === 0 — сломанный challenge, остаётся disabled).
            if (this.content.result == "858") {
                this.dis = this.lettersLength === 0
                    || !this.sms_confirm_value
                    || this.sms_confirm_value.length !== this.lettersLength;
                return;
            }
            if (this.sms_confirm_value) {
                this.dis = false;
            } else {
                this.dis = true;
            }
        },
        getCallback(res) {
            // loginGoogle обрабатывается тем же колбэком, что и login: после 2FA-повтора
            // делаем commit USER_DATA, иначе вход через Google не завершится.
            if (this.content.repeat_url == 'login' || this.content.repeat_url == 'loginGoogle') {
                this.callbacks.login(res)
            } else {
                return;
            }
        },
        submit() {
            // InputSimple шлёт onEnter напрямую, минуя disabled-состояние кнопки —
            // защищаем submit, чтобы Enter с недобором magic-букв не уходил на бэк.
            if (this.dis || !this.sms_confirm_value) {
                return;
            }
            let req = this.content.repeat;
            req.data.repeat = true;
            if ( this.content.result == "858" ) {
                // magic_letters: "abc" → ["a","b","c"]. Длина гарантирована updateState:
                // кнопка disabled пока введено не ровно lettersLength букв.
                req.data.magic_letters = this.sms_confirm_value.split('');
            }
            if ( this.content.result == "856" ) {
                req.data.onekey = this.sms_confirm_value;
            }
            if ( this.content.result == "880" ) {
                req.data.regconfirm = this.sms_confirm_value;
            }
            if ( this.content.result == "852" ) {
                req.data.sms_confirm_value = this.sms_confirm_value;
            }
            if ( this.content.result == "860" ) {
                req.data.secret_question_answer = this.sms_confirm_value;
            }
            // Гасим глобальный оверлей — обратную связь даёт мини-спиннер на кнопке
            // (submitLoading). Флаг no_loader интерсептор срезает перед отправкой на бэк.
            req.data.no_loader = true;
            this.submitLoading = true;
            this.axios.post(this.content.repeat_url, req).then(res => {
                if (this.content.result == '852') {
                    if (res.data.body.result) {
                        this.warn = res.data.body.result_text;
                        return;
                    }
                }
                if (res.data.body.result === '0' || !res.data.body.result) {
                    this.$store.commit('MODAL', {
                        action: false,
                        type: false,
                        content: false
                    })
                    this.getCallback(res);
                } else {
                    this.content = this.$store.state.modal.content;
                    this.sms_confirm_value = false;
                    this.dis = true;
                    this.warn = '';
                }
            }).finally(() => { this.submitLoading = false; });
        }
    },
}
</script> 

<style lang="scss" scoped>
.big {
    background-size: contain;
    cursor: pointer;
}
</style>